import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.inspect');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-inspect',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/page.kiera.inspect/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageKieraInspectComponent implements OnInit, OnDestroy {
    public activeTab: string = 'general';
    public sections: any[] = [];
    public summary: any = { ok: 0, warn: 0 };
    public timestamp: string = '';
    public loading: boolean = false;
    public hasGeneralResult: boolean = false;
    public sidebarItems: any[] = [];
    public sidebarCatalogLoading: boolean = false;
    public sidebarRunningKey: string = '';
    public sidebarRunningMode: string = '';
    public showSidebarConfigModal: boolean = false;
    public sidebarConfigItem: any = null;
    public sidebarConfigMode: 'basic' | 'smoke' = 'smoke';
    public sidebarConfig: any = {};
    public sidebarConfigError: string = '';
    public sidebarPollTimers: { [key: string]: any } = {};
    public langChangeSub: any = null;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.loadPermissions();
        this.langChangeSub = this.translate.onLangChange.subscribe(async () => {
            await this.loadSidebarCatalog();
            if (this.hasGeneralResult) {
                await this.refresh();
            }
        });
        await this.loadSidebarCatalog();
        await this.service.render();
    }

    public ngOnDestroy() {
        if (this.langChangeSub) {
            this.langChangeSub.unsubscribe();
            this.langChangeSub = null;
        }
        for (const timer of Object.values(this.sidebarPollTimers)) {
            clearTimeout(timer);
        }
        this.sidebarPollTimers = {};
    }

    private async callApi(name: string, data: any = {}) {
        return await wiz.call(name, {
            ...(data || {}),
            lang: this.translate.currentLang || this.translate.getDefaultLang() || 'ko',
        });
    }

    public async switchTab(tab: string) {
        this.activeTab = tab;
        await this.service.render();
    }

    public summaryOkText() {
        return this.translate.instant('page.inspect.summary_ok', {
            count: Number(this.summary?.ok || 0),
        });
    }

    public summaryWarnText() {
        return this.translate.instant('page.inspect.summary_warn', {
            count: Number(this.summary?.warn || 0),
        });
    }

    public async loadSidebarCatalog() {
        this.sidebarCatalogLoading = true;
        await this.service.render();
        const { code, data } = await this.callApi('sidebar_catalog');
        this.sidebarCatalogLoading = false;
        if (code === 200) {
            const previous = new Map((this.sidebarItems || []).map((item: any) => [item.key, item]));
            this.sidebarItems = (data.items || []).map((item: any) => {
                const existing = previous.get(item.key) || {};
                return {
                    ...item,
                    lastBasicResult: existing.lastBasicResult || null,
                    lastSmokeResult: existing.lastSmokeResult || null,
                    lastSmokeConfig: existing.lastSmokeConfig || null,
                };
            });
        }
        await this.service.render();
    }

    public async refresh() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await this.callApi('run');
        this.loading = false;
        if (code === 200) {
            this.sections = data.sections || [];
            this.summary = data.summary || { ok: 0, warn: 0 };
            this.timestamp = data.timestamp || '';
            this.hasGeneralResult = true;
        }
        await this.service.render();
    }

    public get canExecute(): boolean { return this.service.auth.can("inspect", "execute"); }

    public async runSidebar(item: any, mode: 'basic' | 'smoke' = 'basic') {
        if (mode === 'smoke' && !this.canExecute) return;
        if (mode === 'smoke' && item?.smoke_form?.fields?.length > 0) {
            await this.openSidebarConfig(item, mode);
            return;
        }
        await this.executeSidebarRun(item, mode);
    }

    public async openSidebarConfig(item: any, mode: 'basic' | 'smoke' = 'smoke') {
        this.sidebarConfigItem = item;
        this.sidebarConfigMode = mode;
        this.sidebarConfigError = '';
        this.sidebarConfig = this.buildSidebarConfigDefaults(item);
        this.showSidebarConfigModal = true;
        await this.service.render();
    }

    public async closeSidebarConfig() {
        this.showSidebarConfigModal = false;
        this.sidebarConfigItem = null;
        this.sidebarConfigMode = 'smoke';
        this.sidebarConfig = {};
        this.sidebarConfigError = '';
        await this.service.render();
    }

    public async confirmSidebarConfig() {
        if (!this.canExecute) return;
        if (!this.sidebarConfigItem) return;

        const fields = this.sidebarConfigItem?.smoke_form?.fields || [];
        for (const field of fields) {
            const value = this.sidebarConfig[field.name];
            if (field.required && (value === '' || value === null || value === undefined)) {
                this.sidebarConfigError = this.translate.instant('page.inspect.modal_required', { label: field.label });
                await this.service.render();
                return;
            }
        }

        const item = this.sidebarConfigItem;
        const mode = this.sidebarConfigMode;
        const config = { ...this.sidebarConfig };
        await this.closeSidebarConfig();
        await this.executeSidebarRun(item, mode, config);
    }

    private buildSidebarConfigDefaults(item: any): any {
        const previous = item?.lastSmokeConfig || {};
        const config: any = { ...previous };
        for (const field of item?.smoke_form?.fields || []) {
            if (config[field.name] !== undefined && config[field.name] !== null && config[field.name] !== '') {
                continue;
            }
            if (field.default !== undefined) {
                config[field.name] = field.default;
                continue;
            }
            if (field.type === 'select') {
                config[field.name] = field.options?.[0]?.value || '';
                continue;
            }
            config[field.name] = '';
        }
        return config;
    }

    private async executeSidebarRun(item: any, mode: 'basic' | 'smoke' = 'basic', config: any = null) {
        if (mode === 'smoke' && !this.canExecute) return;
        this.sidebarRunningKey = item.key;
        this.sidebarRunningMode = mode;
        await this.service.render();

        const payload: any = {
            key: item.key,
            mode,
        };
        if (config && Object.keys(config).length > 0) {
            payload.config = JSON.stringify(config);
        }

        const { code, data } = await this.callApi('sidebar_run', payload);

        const result = code === 200
            ? data.result
            : {
                key: item.key,
                mode,
                status: 'warn',
                checked_at: '',
                summary: data?.message || this.translate.instant('page.inspect.run_failed'),
                detail: data?.message || this.translate.instant('page.inspect.run_failed'),
                steps: [],
            };

        this.updateSidebarResult(item.key, mode, result, config);

        this.sidebarRunningKey = '';
        this.sidebarRunningMode = '';

        if (mode === 'smoke' && result?.job_id && ['pending', 'running'].includes(result.status)) {
            this.startSidebarJobPoll(item.key, result.job_id);
        }

        await this.service.render();
    }

    private updateSidebarResult(itemKey: string, mode: 'basic' | 'smoke', result: any, config: any = null) {
        this.sidebarItems = (this.sidebarItems || []).map((row: any) => {
            if (row.key !== itemKey) return row;
            if (mode === 'smoke') {
                return {
                    ...row,
                    lastSmokeResult: result,
                    lastSmokeConfig: config || row.lastSmokeConfig || null,
                };
            }
            return { ...row, lastBasicResult: result };
        });
    }

    private startSidebarJobPoll(itemKey: string, jobId: string) {
        this.stopSidebarJobPoll(itemKey);
        this.sidebarPollTimers[itemKey] = setTimeout(async () => {
            const { code, data } = await this.callApi('sidebar_job_status', { job_id: jobId });
            const result = code === 200
                ? data.result
                : {
                    key: itemKey,
                    mode: 'smoke',
                    status: 'warn',
                    checked_at: '',
                    summary: data?.message || this.translate.instant('page.inspect.poll_failed'),
                    detail: data?.message || this.translate.instant('page.inspect.poll_failed'),
                    steps: [],
                };

            this.updateSidebarResult(itemKey, 'smoke', result);

            if (['pending', 'running'].includes(result?.status || '')) {
                this.startSidebarJobPoll(itemKey, jobId);
            } else {
                this.stopSidebarJobPoll(itemKey);
            }

            await this.service.render();
        }, 5000);
    }

    private stopSidebarJobPoll(itemKey: string) {
        if (!this.sidebarPollTimers[itemKey]) return;
        clearTimeout(this.sidebarPollTimers[itemKey]);
        delete this.sidebarPollTimers[itemKey];
    }

    public sidebarBusy(item: any, mode: 'basic' | 'smoke' = 'basic'): boolean {
        if (mode === 'smoke' && ['pending', 'running'].includes(item?.lastSmokeResult?.status || '')) {
            return true;
        }
        return this.sidebarRunningKey === item.key && this.sidebarRunningMode === mode;
    }

    public smokeButtonLabel(item: any): string {
        return item?.smoke_label || this.translate.instant('page.inspect.smoke_test');
    }

    public smokeResultLabel(item: any): string {
        return item?.smoke_label || this.translate.instant('page.inspect.smoke_test');
    }

    public statusBadgeClass(status: string): string {
        if (status === 'ok') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (status === 'warn') return 'bg-amber-50 text-amber-700 border-amber-200';
        if (status === 'running') return 'bg-sky-50 text-sky-700 border-sky-200';
        if (status === 'pending') return 'bg-zinc-50 text-zinc-600 border-zinc-200';
        return 'bg-zinc-50 text-zinc-500 border-zinc-200';
    }

    public statusLabel(status: string): string {
        if (status === 'ok') return this.translate.instant('page.inspect.status.ok');
        if (status === 'warn') return this.translate.instant('page.inspect.status.warn');
        if (status === 'running') return this.translate.instant('page.inspect.status.running');
        if (status === 'pending') return this.translate.instant('page.inspect.status.pending');
        return this.translate.instant('page.inspect.status.pending');
    }

    public iconFor(s: string): string {
        if (s === 'ok') return 'bx-check-circle text-emerald-600';
        if (s === 'warn') return 'bx-error-circle text-amber-600';
        if (s === 'running') return 'bx-loader-alt text-sky-600 animate-spin';
        if (s === 'pending') return 'bx-time text-zinc-500';
        return 'bx-x-circle text-rose-600';
    }
}

export default PageKieraInspectComponent;
